import React from 'react';
import { Box, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { ClickTypes } from '../../types';
import { FormattedMessage, useIntl } from 'react-intl';

export interface ClicksRowProps {
  clicks: number;
  clickType: ClickTypes;
}

export const ClicksRow: React.FC<ClicksRowProps> = ({ clicks, clickType }) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="ClicksRow"
      icon={{ name: 'playback/clicked' }}
      label={{
        body: intl.formatMessage(
          {
            defaultMessage:
              '{clickType, select, error_clicked {Error Clicks} rage_clicked {Rage Clicks} dead_clicked {Dead Clicks} other {Clicks}}',
            id: 'Mg+4by',
          },
          { clickType },
        ),
      }}
      value={{ body: intl.formatNumber(clicks) }}
      tooltipContent={
        <Box>
          <Text appearance="bodySmall" color="inherit">
            <FormattedMessage
              defaultMessage="Total {clickType, select, error_clicked {error clicks} rage_clicked {rage clicks} dead_clicked {dead clicks} other {clicks}} for all users in this Segment on this page. Some {clickType, select, error_clicked {error clicked} rage_clicked {rage clicked} dead_clicked {dead clicked} other {clicked}} elements may not currently be visible."
              id="a0DtWz"
              values={{
                clickType,
              }}
            />
          </Text>
        </Box>
      }
    />
  );
};
